class Platform {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.width = 95;
    this.height = 30;
    this.speed = 1;
  }
}

module.exports = Platform